// AI Generated component
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MonModalService } from 'app/modules/modals/services/mon-modal/mon-modal.service';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { DateTimeService } from 'app/services/date-time/date-time.service';
import { PipeService } from '../../../filters/pipe-transformation.service';
import { LabelRepo } from '@monsido/modules/endpoints/api/label.repo';
import { SpellingToolRepoService } from '../../../services/api/spelling-tool-repo/spelling-tool-repo.service';
import { PageService } from '@client/app/services/entities/page/page.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { MON_MODULES } from '@client/ng2/core/constants/mon-modules.constant';
import { Subscription } from 'rxjs';
import { LabelTableService } from '@client/app/services/label-table/label-table.service';

@Component({
    selector: 'page-details',
    standalone: false,
    template: `
        <div class="page-details-view d-flex flex-column">
            <div class="pl-12 mr-0 pr-0 pb-3 d-flex align-items-center page-details-heading row">
                <div class="ml-2 pr-9 mr-auto page-details-title col-sm-48">
                    <div class="text-ellipsis">
                        <h1 data-test="page-details-heading" class="mt-0 mb-1 text-ellipsis">{{page.title || '(' + ('No title found' | translate) + ')'
                            }}</h1>
                        <a data-test="page-url" [href]="page.url" target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'" class="text-nowrap">
                            <span class="fas fa-external-link-alt" aria-hidden="true"></span>
                            {{ page.url}}
                        </a>
                    </div>
                    <label-container [currentLabels]="page.labels"
                                     class="inline-block pt-1"
                                     [attr.aria-label]="'Labels' | translate"
                                     (getLabels)="getLabels()"
                                     [allLabels]="allLabels"
                                     (onUpdateLabel)="updatePage(page)"
                                     [labelsNoBeforeMinimize]="7"
                                     [allowEdit]="labelTableService.canAssignLabels">
                    </label-container>
                </div>
                <div class="d-flex flex-column align-items-end pr-9 ml-5">
                    <div>
                        <a [href]="cmsUrl"
                           target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'"
                           class="btn btn-border-radius btn-secondary my-1"
                           monEventTrigger="actionTrigger"
                           [monEventParams]="{action: 'open-in-'+openInCMSButtonText()}"
                           *ngIf="cmsUrl">
                            {{ openInCMSButtonText() }}
                        </a>
                        <a class="btn btn-border-radius btn-secondary my-1"
                           [ngbTooltip]="('Please select CMS to activate this feature' | translate)"
                           [triggers]="'focus hover'"
                           *ngIf="!cmsUrl && ('demo' | monCustomerHasPlan)"
                           [attr.aria-disabled]="true"
                           [attr.disabled]="true"
                           role="button"
                           href>
                            {{ openInCMSButtonText() }}
                        </a>
                        <sop-button [page]="page" class="inline-block mr-1"></sop-button>
                        <mon-extension-visual-link-button [tooltipPlacement]="'bottom'" [page]="page"></mon-extension-visual-link-button>
                        &nbsp;
                        <button class="btn btn-border-radius btn-secondary"
                                type="button"
                                data-test="page-rescan-button"
                                (click)="rescan()"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-rescan'}"
                                [disabled]="checkIfSinglePageScanIsRunning"
                                [triggers]="'focus hover'"
                                [ngbTooltip]="('Re-scan this page' | translate)"
                                [container]="'body'" aria-hidden="true">
                            <span class="fas fa-sync" [ngClass]="{'fa-spin': checkIfSinglePageScanIsRunning}" aria-hidden="true"></span>
                         </button>
                    </div>
                </div>
            </div>
            <div class="page-details-topmenu">
                <nav [attr.aria-label]="('Page Details Navigation' | translate)">
                    <ul class="page_details_submenu">
                        <li [ngClass]="{'active': link === active, 'mon-disabled': link.isDisabled === true}"
                            [attr.data-test]="('menu-' + link.name | e2eAttributeEncoding)"
                            [attr.aria-disabled]="link.isDisabled === true"
                            (click)="link.isDisabled !== true && setActiveSection(link)"
                            monEventTrigger="actionTrigger"
                            [monEventParams]="{action: link.component+'-btn'}"
                            *ngFor="let link of links"
                            [hidden]="link.hasOwnProperty('show') && !link.show"
                            [attr.aria-label]="link.name"
                            class="cursor-pointer">
                            <span [ngClass]="link.icon" aria-hidden="true"></span>&nbsp;
                            <span class="visible-md-inline visible-lg-inline" [innerHTML]="link.name"></span>
                            <span class="text-grey ml-1">{{ link.count }}</span>
                            <span class="label label-new text-v-top" *ngIf="link.isBeta" translate>BETA</span>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="row" *ngIf="manualScanned()">
                <div class="col-48 inner-none">
                    <div class="alert alert-info text-center" style="margin-bottom: 0px;">
                        <strong translate>Important notification:</strong>&nbsp;
                        <span translate>
                            This page has been rescanned since the latest full scan.
                        </span>&nbsp;
                        <i>
                        <span class="text-bold"
                              translate
                              [translate-args]="{scannedAt: page.lastcheck | userDate:'lll'}">
                            Latest manual scan finished on [[scannedAt]]
                        </span>
                        </i>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="scanStatusObj?.status === 'failed'">
                <div class="col-48 inner-none">
                    <div class="alert alert-danger text-center" style="margin-bottom: 0px;">
                        <strong translate>Important notification:</strong>&nbsp;
                        <span>
                            {{ scanStatusObj.failure_reason }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="page-details-section flex-grow-1 row d-flex align-items-stretch">
                <div class="col-48"
                     [ngClass]="{'bg-light-grey': active.component === 'page-details-section-dashboard' || active.component === 'page-details-section-statistics'}">
                    <div class="page-details-section pr-3">
                            <page-details-section-dashboard (onClickHandler)="dashboardNavigateTo($event.params)"
                                                            (updatePage)="updatePage($event.page)"
                                                            [page]="page"
                                                            [languages]="languages"
                                                            *ngIf="active.component === 'page-details-section-dashboard'">
                            </page-details-section-dashboard>
                            <page-details-section-policies [page]="page"
                                                           [active]="subTarget"
                                                           (refreshPage)="refreshPage($event)"
                                                           *ngIf="active.component === 'page-details-section-policies' && ('global_policy' | activeFeature)">
                            </page-details-section-policies>
                            <page-details-section-qa [page]="page"
                                                     [active]="subTarget"
                                                     (refreshPage)="refreshPage($event)"
                                                     *ngIf="active.component === 'page-details-section-qa'">
                            </page-details-section-qa>
                            <page-details-section-inventory [page]="page"
                                                            [active]="subTarget"
                                                            *ngIf="active.component === 'page-details-section-inventory'">
                            </page-details-section-inventory>
                            <page-details-section-statistics [page]="page"
                                                             [active]="subTarget"
                                                             *ngIf="active.component === 'page-details-section-statistics'">
                            </page-details-section-statistics>
                            <page-details-section-seo [page]="page"
                                                      [active]="subTarget"
                                                      (refreshPage)="refreshPage($event)"
                                                      *ngIf="active.component === 'page-details-section-seo'">
                            </page-details-section-seo>
                            <page-details-section-accessibility [page]="page"
                                                                [active]="subTarget"
                                                                *ngIf="active.component === 'page-details-section-accessibility'"
                                                                (refreshPage)="refreshPage($event)">
                            </page-details-section-accessibility>
                            <page-details-section-page-performance [page]="page"
                                                                   [active]="subTarget"
                                                                   *ngIf="performanceShowSection()">
                            </page-details-section-page-performance>
                            <page-details-section-data-privacy [pageObj]="page"
                                                               [active]="subTarget"
                                                               *ngIf="active.component === 'page-details-section-data-privacy'"
                                                               (refreshPage)="refreshPage($event.target)">
                            </page-details-section-data-privacy>
                        </div>
                    </div>
                </div>
        </div>
    `,
})
export class PageDetailsComponent implements OnInit, OnDestroy {
    @Input() page: any;
    @Input() target: any;
    @Input() subTarget: any;

    scanStatusObj: any = null;
    links: any[] = [];
    languages: any[] = [];
    cmsUrl: string = '';
    isAdmin: boolean = false;
    active: any = {};
    checkJobTimeout: any = null;
    checkIfSinglePageScanIsRunning: boolean = false;
    scanStatus: Subscription | null = null;
    allLabels: any[] = [];
    infoType: string = '';

    constructor (
        private labelRepo: LabelRepo,
        private sessionService: SessionService,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private spellingToolRepoService: SpellingToolRepoService,
        private pageService: PageService,
        private loginService: LoginService,
        private monModalService: MonModalService,
        private pageRepoService: PageRepoService,
        private dateTimeService: DateTimeService,
        private pipeService: PipeService,
        public labelTableService: LabelTableService,
    ) {}

    ngOnInit () {
        this.scanStatusObj = null;
        this.target = this.target || this.stateService.params.target || null;
        this.links = [];
        this.subTarget = this.subTarget || this.stateService.params.sub_target || null;
        this.languages = [];
        this.cmsUrl = '';
        this.getCmsUrl();
        this.getPage(true);
        this.isAdmin = this.sessionService.hasRole('customer_admin');
        this.checkJobTimeout = null;
        this.checkIfSinglePageScanIsRunning = false;
        this.scanStatus = null;
        this.getLabels();
        this.getLanguages();
        this.manualScanned();
        if (this.page.latest_page_scan_status === 'failed') {
            this.getScanStatus();
        }
        if (
            this.page.latest_page_scan_status &&
            !(this.page.latest_page_scan_status === 'completed' || this.page.latest_page_scan_status === 'failed')
        ) {
            this.checkIfSinglePageScanIsRunning = true;
            this.observeSinglePageScanStatus();
        }
    }

    ngOnDestroy () {
        if (this.scanStatus && !this.scanStatus.closed) {
            this.scanStatus.unsubscribe();
            this.scanStatus = null;
        }
    }

    getScanStatus () {
        return this.pageRepoService.getScanStatus(this.page.id).then((data: any) => {
            this.scanStatusObj = data;
        }, () => {});
    }

    dashboardNavigateTo (params: any) {
        this.target = params.target;
        this.subTarget = params.subTarget;
        this.setupActive();
    }

    getPage (runSetupActive: boolean) {
        this.pageService.get(this.page.id).then((page: any) => {
            this.page = page;
            this.setupLinks(runSetupActive);
        }, () => {});
    }

    refreshPage (payload: any) {
        if (payload.target) {
            this.target = payload.target;
        } else {
            this.target = payload;
        }
        this.getPage(true);
    }

    setActiveSection (section: any) {
        this.active = section;
    }

    setupActive () {
        let selected = null;
        if (this.target) {
            for (let i = 0; i < this.links.length; i++) {
                if (this.links[i].component === this.target) {
                    selected = this.links[i];
                }
            }
        }
        this.active = selected || this.links[0];
    }

    setupLinks (runSetupActive: boolean) {
        this.loginService.getUser().then((user: any) => {
            user = user === null ? this.sessionService.me : user;
            this.links = [];
            let links = [
                {
                    name: this.translateService.getString('Page dashboard'),
                    count: '',
                    component: 'page-details-section-dashboard',
                    icon: this.pipeService.get('monIcons')(['MENUES', 'DASHBOARD']),
                    module: null,
                },
                {
                    name: this.translateService.getString('Content Quality'),
                    count: this.page.getQualityNotificationsCount(),
                    component: 'page-details-section-qa',
                    show: this.activeFeatureService.isFeatureActivePure('qa_module'),
                    icon: this.pipeService.get('monIcons')(['MENUES', 'QA']),
                    module: MON_MODULES.qa,
                },
                {
                    name: this.translateService.getString('Accessibility'),
                    count: this.page.accessibility_checks_with_errors_count,
                    component: 'page-details-section-accessibility',
                    show: !!this.sessionService.domain?.features.accessibility,
                    icon: this.pipeService.get('monIcons')(['MENUES', 'ACCESSIBILITY']),
                    module: MON_MODULES.accessibility,
                },
                {
                    name: this.translateService.getString('SEO Issues'),
                    count: this.page.seo_issues_count,
                    component: 'page-details-section-seo',
                    show: this.activeFeatureService.isFeatureActivePure('seo_all'),
                    icon: this.pipeService.get('monIcons')(['MENUES', 'SEO']),
                    module: MON_MODULES.seo,
                },
                {
                    name: this.translateService.getString('Site Analytics'),
                    count: '',
                    show: this.allowStatistics(),
                    component: 'page-details-section-statistics',
                    icon: this.pipeService.get('monIcons')(['MENUES', 'STATISTICS']),
                    module: MON_MODULES.statistics,
                },
                {
                    name: this.translateService.getString('Data Privacy'),
                    count: '',
                    component: 'page-details-section-data-privacy',
                    icon: this.pipeService.get('monIcons')(['MENUES', 'DATA_PRIVACY']),
                    hasAccess: this.pipeService.get('monCustomerHasPlan')('demo') || this.activeFeatureService.isFeatureActive(MON_MODULES.data_privacy),
                    module: MON_MODULES.data_privacy,
                },
                {
                    name: this.translateService.getString('Site Inventory'),
                    count: '',
                    show: this.activeFeatureService.isFeatureActivePure('inventory_all'),
                    component: 'page-details-section-inventory',
                    icon: this.pipeService.get('monIcons')(['MENUES', 'INVENTORY']),
                    module: MON_MODULES.inventory,
                },
                {
                    name: this.translateService.getString('Performance Scans'),
                    count: '',
                    component: 'page-details-section-page-performance',
                    icon: this.pipeService.get('monIcons')(['MENUES', 'PAGE_PERFORMANCE']),
                    module: null,
                    hasAccess:
                        this.activeFeatureService.isFeatureActive('page_performance') && this.pipeService.get('hasAccess')(user, MON_MODULES.performance),
                    isDisabled: !this.activeFeatureService.isFeatureActive('page_page_performance', undefined, this.page),
                    isBeta: false,
                },
            ];
            links = this.addFeatures(links);
            links.forEach((link: any) => {
                if (
                    (link.module === null || this.pipeService.get('hasAccess')(user, link.module)) &&
                    (typeof link.hasAccess !== 'boolean' || link.hasAccess)
                ) {
                    this.links.push(link);
                }
            });

            if (runSetupActive) {
                this.setupActive();
            }
        }, () => {});
    }

    addFeatures (links: any[]) {
        if (this.activeFeatureService.isFeatureActivePure('policies_all')) {
            links.splice(1, 0, {
                name: this.translateService.getString('Content Policies'),
                count: this.page.policy_violation_count + this.page.policy_required_count + this.page.policy_search_count,
                component: 'page-details-section-policies',
                icon: this.pipeService.get('monIcons')(['MENUES', 'POLICIES']),
                module: MON_MODULES.policies,
            });
        }

        return links;
    }

    getLabels () {
        this.labelRepo.getLabels().then((data: any) => {
            this.allLabels = data;
        }, () => {});
    }

    updatePage (page: any) {
        const params = {
            language: this.page.language,
            labels: page.labels.map((label: any) => {
                return label.id;
            }),
        };
        this.pageService.update(page, params);
    }

    openInCMSButtonText () {
        let text = this.translateService.getString('CMS');
        if (this.sessionService.domain) {
            switch (this.sessionService.domain.cms) {
                case 'presence':
                    text = this.translateService.getString('Presence');
                    break;
                case 'gabbart':
                    text = this.translateService.getString('Harmony CMS');
                    break;
            }
        }

        return text;
    }

    getLanguages () {
        this.spellingToolRepoService.get().then((data: any) => {
            this.languages = data;
        }, () => {});
    }

    allowStatistics () {
        if (this.pipeService.get('monCustomerHasPlan')('demo')) {
            return true;
        }
        if (this.sessionService.domain && this.sessionService.domainGroup === null) {
            return this.sessionService.domain.features.statistics;
        } else if (this.sessionService.domain && this.sessionService.domainGroup !== null) {
            return (
                this.sessionService.domain.features.statistics &&
                this.sessionService.customer !== null &&
                this.sessionService.customer.plan_traits.domain_group_statistics
            );
        }
        return false;
    }

    performanceShowSection () {
        return (
            this.active &&
            this.activeFeatureService.isFeatureActive('page_page_performance', undefined, this.page) &&
            this.active.component === 'page-details-section-page-performance'
        );
    }

    rescan () {
        this.checkIfSinglePageScanIsRunning = true;
        this.pageService.rescanPageDetail(this.page.id).then((data: any) => {
            this.observeSinglePageScanStatus();
            this.monModalService
                .alert(
                    this.translateService.getString('Re-scanning of issues for this page has started and will be finished in a few minutes.'),
                )
                .then(() => {}, () => {});
        }, () => {});
    }

    getCmsUrl () {
        this.pageService.getCmsUrlPageDetail(this.page.id).then((data: any) => {
            return this.cmsUrl = data.cms_url;
        }, () => {});
    }

    /**
     * If a single page scan time is newer than the last scan in our database, and the blue notification bar will be displayed.
     */
    manualScanned () {
        if (this.sessionService.domain === null || !this.sessionService.domain.crawl_history) {
            return false;
        }

        const lastScan = this.sessionService.domain.crawl_history.post_processing_done_at;
        const lastManuelScan = this.page.lastcheck;
        if (!lastManuelScan) {
            return false;
        }
        return this.dateTimeService.isAfter(lastManuelScan, lastScan);
    }

    observeSinglePageScanStatus () {
        const interval = setInterval(() => {
            return this.pageRepoService.getScanStatus(this.page.id).then((data: any) => {
                this.scanStatusObj = data;
                if (data.status === 'completed' || data.status === 'failed') {
                    this.checkIfSinglePageScanIsRunning = false;
                    clearInterval(interval);
                    this.getPage(false);
                }
                return data;
            }, () => {});
        }, 30000);
    }
}
